import React, { Component } from "react";
import RugAPI from "../../../api/rug";

export default class RugCity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cities: [],
      search: null,
      searchTimeout: null,
      selectedCities: [],
      seachOpen: false
    };
  }

  loadCities = () => {
    const api = new RugAPI();
    api.getRugCities(this.state.search).then(response => {
      if (response.success) {
        this.setState({ cities: response.data.results });
      }
    });
  };

  componentDidMount() {
    this.loadCities();
  }

  setSearch = search => {
    this.setState({ search: search }, () => {
      this.loadCities();
    });
  };

  searchChangeHandler = evt => {
    clearTimeout(this.state.searchTimeout);
    const search = evt.target.value;
    if (search.length > 1) {
      const timeout = setTimeout(() => this.setSearch(search), 300);
      this.setState({ searchTimeout: timeout });
    }
  };

  citySelectHandler = city => {
    this.setState({seachOpen: false})
    if (this.state.selectedCities.length === 0) {
      this.setState({ selectedCities: [city] });
    } else {
      const found = this.state.selectedCities.findIndex(
        selected => selected.id === city.id
      );
      let newData = [...this.state.selectedCities];
      if (found !== -1) {
        newData.splice(found, 1);
      } else {
        newData.push(city);
      }
      this.setState({ selectedCities: newData });
    }
    this.props.changeCitiesHandler(city.id);
  };

  componentWillUnmount() {
    clearTimeout(this.state.searchTimeout)
  }

  render() {
    return (
      <div className="city-filter-body">
        <div className="search-body">
          <div className="mobile-size m-0">
            <p className="m-0">شهر:</p>
            <div className="search-form">
              <input
                type="search"
                className="search"
                placeholder=" تایپ کنید ... "
                onChange={this.searchChangeHandler}
                onClick={() =>
                  this.setState({ seachOpen: !this.state.seachOpen })
                }
              />
              <ul
                className={
                  this.state.seachOpen ? "multi-select active" : "multi-select"
                }
              >
                {this.state.cities.map(city => (
                  <li
                    className={
                      this.props.selectedCitiesIDs.indexOf(city.id) !== -1
                        ? "active"
                        : ""
                    }
                    key={"city" + city.id}
                    onClick={() => this.citySelectHandler(city)}
                  >
                    {city.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="selected-body">
            {this.state.selectedCities.map(city => (
              <span
                key={"selectedCity" + city.id}
                onClick={() => this.citySelectHandler(city)}
              >
                <button className="close fat black" />
                {city.name}
              </span>
            ))}
          </div>
        </div>
      </div>
    );
  }
}
